const isDefinedPromise = (action) => typeof action === "object" && Promise.resolve(action) === action;
const nextFrame = () => new Promise((resolve) => {
  requestAnimationFrame(() => resolve(void 0));
});
const elementUpdated = async (el) => {
  let updated = false;
  const update = el && el.updateComplete;
  if (isDefinedPromise(update)) {
    updated = await update;
  }
  if (!updated) {
    await nextFrame();
  }
  return updated;
};
export {
  elementUpdated,
  nextFrame
};
//# sourceMappingURL=element-updated.js.map
